import { render, staticRenderFns } from "./DocumentationThemes.vue?vue&type=template&id=64733d12&scoped=true&"
import script from "./DocumentationThemes.vue?vue&type=script&lang=js&"
export * from "./DocumentationThemes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64733d12",
  null
  
)

export default component.exports